export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const VERIFY_CODE_REQUEST = 'VERIFY_CODE_REQUEST';
export const VERIFY_DOB_REQUEST = 'VERIFY_CODE_REQUEST';



// WEBPACK FOOTER //
// ./src/actions/session/types.js